/**
 * AccessDeniedScreen — shown when the user lacks the `ViaMind.Viewer` role
 * (task 3.13, 5.7; Req 5.1, 5.3, 20.1, 25.5).
 *
 * Renders a centered white card on the neutral canvas explaining the user does
 * not have access, and a sign-out button that clears the cached token and
 * returns the app to the unauthenticated state (Req 20.1, 20.2, 20.3).
 *
 * Design-system styling: centered white card, heading/medium title, blue
 * primary sign-out button, Roboto (Req 25.5, 26.2, 26.3).
 */

import { useSignOut } from "../auth/adapters";

/**
 * Access-denied screen displayed by the RoleGate when the authenticated user
 * does not hold the required `ViaMind.Viewer` role.
 */
export default function AccessDeniedScreen() {
  const signOut = useSignOut();

  return (
    <div className="auth-screen" role="main" aria-label="Access denied">
      <div className="auth-card">
        <h1 className="auth-card__title">Access Denied</h1>
        <p className="auth-card__message">
          Your account does not have the <strong>ViaMind.Viewer</strong> role
          required to view this dashboard. Contact your administrator to request
          access.
        </p>
        <button
          type="button"
          className="auth-card__action ds-btn ds-btn--primary"
          onClick={() => void signOut()}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
